import { useEffect, useReducer } from 'react';
import { ColumnColoringMode } from '@shared/utils/Table/TableColumn.interface';
import { TableCellTextStyle } from '../Cells/TableCellTextStyle';
export function useTableBodyRow(rowPrevValuesCache, row, subscribeRowUpdate) {
    const [, rerender] = useReducer((n) => n + 1, 0);
    useEffect(() => {
        if (isNullOrUndefined(subscribeRowUpdate)) {
            return;
        }
        return subscribeRowUpdate(row.id, rerender);
    }, [subscribeRowUpdate, row.id]);
    const getCellTextStyle = (column) => {
        var _a, _b;
        if (column.coloringMode === ColumnColoringMode.Previous && rowPrevValuesCache !== null) {
            const prevValue = (_a = rowPrevValuesCache.get(column.id)) === null || _a === void 0 ? void 0 : _a.prevValue;
            const newValue = (_b = rowPrevValuesCache.get(column.id)) === null || _b === void 0 ? void 0 : _b.newValue;
            if (isValidNumber(prevValue) === false || isValidNumber(newValue) === false) {
                return TableCellTextStyle.Default;
            }
            else if (newValue > prevValue) {
                return TableCellTextStyle.Positive;
            }
            else if (newValue < prevValue) {
                return TableCellTextStyle.Negative;
            }
        }
        else if (column.coloringMode === ColumnColoringMode.Signed) {
            const value = row.data.getValue(column.id);
            if (!isValidNumber(value) || value === 0) {
                return TableCellTextStyle.Default;
            }
            else if (value > 0) {
                return TableCellTextStyle.Positive;
            }
            else if (value < 0) {
                return TableCellTextStyle.Negative;
            }
        }
        else {
            return TableCellTextStyle.Default;
        }
    };
    return {
        getCellTextStyle
    };
}
